import React, { useEffect, useState, useContext } from "react";
import { Link } from "gatsby";
import resolveLink from "../../utils/resolveLink";
import { PageContext } from "src/utils/context";

const FixedCta = () => {
  const [scrolled, setScrolled] = useState(false);

  const { button_override_title } = useContext(PageContext);
  const { button_override_url } = useContext(PageContext);

  useEffect(() => {
    window.addEventListener("scroll", function () {
      if (
        window.scrollY > 200 &&
        window.scrollY + window.innerHeight < document.body.offsetHeight - 200
      ) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    });
  }, []);

  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    window.addEventListener("click", function () {
      if (document.body.style.overflow === "hidden") {
        setHidden(true);
      } else {
        setHidden(false);
      }
    });
  }, []);

  return (
    <div
      className={`fixed bottom-0 right-0 flex transition duration-300 z-50 ${hidden} ${
        scrolled && hidden ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className={`bg-red px-6`}>
        {button_override_url?.cached_url ? (
          <Link
            className="inline-block font-display uppercase text-lg px-3 leading-[3em] text-white line-crop tracking-button transition duration-300 hover:opacity-50"
            to={resolveLink(`/${button_override_url.cached_url}`)}
          >
            {button_override_title}
          </Link>
        ) : (
          <Link
            className="inline-block font-display uppercase text-lg px-3 leading-[3em] text-white line-crop tracking-button transition duration-300 hover:opacity-50"
            to={resolveLink(`/cx-insights-hub`)}
          >
            Search the CX Insights Hub
          </Link>
        )}
      </div>
    </div>
  );
};

export default FixedCta;
